const MAX_ROWS_TO_RENDER = 1000;

RivalIQ.apps.Admin.apps.Query.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const identityFormatter = function (value) {
        return _.escape(value);
    };

    // TODO: environment-specific export host name export-staging.rivaliq.com vs export.rivaliq.com
    const exportDirectoryLink = function (uuid) {
        const escapedUuid = _.escape(uuid);
        return `<a target="_blank" href="https://export.rivaliq.com/dir/${escapedUuid}/">${escapedUuid}</a>`;
    };

    const queryFormatters = {
        'Failed Exports': function (value, colHeader) {

            const columns = {
                'export_uuid': exportDirectoryLink(value)
            };

            return columns[colHeader] || identityFormatter(value);
        }
    };

    views.Delete = Marionette.ItemView.extend({

        template: '#queryDeleteTemplate',

        ui: {
            deleteBtn: '.x-delete-dataclip'
        },

        events: {
            'click @ui.deleteBtn': 'delete'
        },

        delete: function () {
            const me = this;

            me.ui.deleteBtn.button('loading');

            me.model.destroy({
                success: function () {
                    me.$el.find('.modal').modal('hide');
                    window.location = '#/queries';
                }
            }).fail(function () {
                RivalIQ.apps.Admin.queryTab.showError();
            });
        }

    });

    views.Query = Marionette.CompositeView.extend({

        template: '#adminQueryQueryTemplate',

        ui: {
            queryDisplay: '.x-query-display',
            queryEdit: '.x-query-edit',
            editBtn: '.x-edit',
            deleteBtn: '.x-delete',
            saveBtn: '.x-save',
            downloadCsvBtn: '.x-download-csv',
            downloadJsonBtn: '.x-download-json',
            refreshBtn: '.x-refresh',
            queryName: '#inputQueryName',
            queryText: '#inputQueryText'
        },

        events: {
            'click @ui.editBtn': 'edit',
            'click @ui.deleteBtn': 'delete',
            'click @ui.saveBtn': 'save',
            'click @ui.downloadCsvBtn': 'downloadCsv',
            'click @ui.downloadJsonBtn': 'downloadJson',
            'click @ui.refreshBtn': 'refresh'
        },

        templateHelpers: function () {
            const me = this;

            const queryName = me.model.get('name');
            const queryText = me.model.get('query');
            const queryResults = me.model.get('queryResults');
            const queryError = me.model.get('queryError');

            const cols = _.map(_.get(queryResults, ['fields']), function (field) {
                return field.name;
            });

            const rowsReturned = _.get(queryResults, ['rows', 'length']) || 0;
            const rows = _.map(
                _.take(_.get(queryResults, ['rows']), MAX_ROWS_TO_RENDER),
                function (row) {
                    return _.map(cols, function (col) {
                        return row[col];
                    });
                }
            );

            return {
                queryName: queryName,
                queryText: queryText,
                queryError: queryError,
                cols: cols,
                rows: rows,
                rowsReturned: rowsReturned,
                rowsRendered: rows.length,
                columnFormatter: queryFormatters[queryName] || identityFormatter
            };
        },

        onRender: function () {
            const me = this;

            // NOTE if its an brand new clip, or it has an error, go right into edit mode
            if (me.model.get('name') === App.defaultQueryName || me.model.get('queryError')) {
                me.editMode = true;
            }

            if (me.editMode) {
                me.enterEditMode();
            }
        },

        edit: function () {
            const me = this;

            me.editMode = true;
            me.enterEditMode();
        },

        enterEditMode: function () {
            const me = this;

            me.ui.queryDisplay.hide();
            me.ui.queryEdit.show();
        },

        delete: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.Delete({
                model: me.model
            }));
        },

        save: function () {
            const me = this;

            me.ui.saveBtn.button('loading');

            me.model.save(me.serialize(), {
                patch: true
            }).done(function () {
                me.refresh();
            }).fail(function () {
                RivalIQ.apps.Admin.queryTab.showError();
            });
        },

        serialize: function () {
            const me = this;

            const results = {
                name: me.ui.queryName.val(),
                query: me.ui.queryText.val()
            };
            return results;
        },

        downloadCsv: function () {
            const me = this;
            window.open(me.model.exportLink('csv'), '_blank');
        },

        downloadJson: function () {
            const me = this;
            window.open(me.model.exportLink('json'), '_blank');
        },

        refresh: function () {
            const me = this;

            me.ui.refreshBtn.button('loading');

            me.model.fetch().done(function () {
                me.render();
            }).fail(function () {
                RivalIQ.apps.Admin.queryTab.showError();
            });
        }

    });
});
